<template>
  <div>
    <h4>Thống kê</h4>
    <el-row>
      <el-col :span="6">
        <NumberInfo label="tổng số tài liệu" :number="totalUploadDocument"/>
      </el-col>
      <el-col :span="6">
        <NumberInfo label="tổng số người dùng" :number="totalRegisterUser"/>
      </el-col>
      <el-col :span="6">
        <NumberInfo label="tài liệu mới" :number="totalNewUploadDocument"/>
      </el-col>
      <el-col :span="6">
        <NumberInfo label="người dùng mới" :number="totalNewRegisterUser"/>
      </el-col>
    </el-row>
    <br />
    <br />
    <el-row>
      <h5>Số tài liệu xử lý gần đây</h5>
      <br />
      <el-col :span="10" :push="1" class="center">
        <h6 class="text-center">7 ngày gần đây</h6>
        <ve-line :data="documentWeekData" :settings="documentWeekDataChartSetting"> </ve-line>
      </el-col>
      <el-col :span="10" :push="2">
        <h6 class="text-center">12 giờ gần đây</h6>
        <ve-line :data="documentHourData" :settings="documentWeekDataChartSetting"></ve-line>
      </el-col>
    </el-row>
    <el-row>
      <h5>Số người dùng đăng ký gần đây</h5>
      <br />
      <el-col :span="10" :push="1">
        <h6 class="text-center">7 ngày gần đây</h6>
        <ve-line :data="userWeekData" :settings="userWeekDataChartSetting"> </ve-line>
      </el-col>
      <el-col :span="10" :push="2">
        <h6 class="text-center">12 giờ gần đây</h6>
        <ve-line :data="userHourData" :settings="userWeekDataChartSetting"></ve-line>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { apiGetStatistic } from "@/services/admin_dashboard_service"
import VeLine from "v-charts/lib/line.common"

import moment from "moment"
import FAIcon from "@/components/common/FAIcon.vue"
import StatisticInfoCard from "@/components/common/StatisticInfoCard.vue"
import NumberInfo from "@/components/HomeComponents/NumberInfo.vue"

export default {
  name: "AdminGeneralStatistic",
  data: () => {
    return {
      statistic: {},
      documentWeekData: {
        columns: ["date", "total", "complete", "error"],
        rows: [],
      },
      documentHourData: {
        columns: ["date", "total", "complete", "error"],
        rows: [],
      },
      userWeekData: {
        columns: ["date", "active", "inactive"],
        rows: [],
      },
      userHourData: {
        columns: ["date", "active", "inactive"],
        rows: [],
      },
      documentWeekDataChartSetting: {
        labelMap: {
          total: "Tất cả",
          complete: "Đã kiểm tra",
          error: "Lỗi",
        },
      },
      userWeekDataChartSetting: {
        labelMap: {
          active: "Kích hoạt",
          inactive: "Đã kích hoạt",
        },
      },
      totalUploadDocument: 0,
      totalRegisterUser: 0,
      totalNewRegisterUser: 0,
      totalNewUploadDocument: 0,
    }
  },
  components: {
    NumberInfo,
    StatisticInfoCard,
    VeLine,
    FAIcon,
  },
  async mounted() {
    try {
      let res = await apiGetStatistic()
      console.log(res)
      this.statistic = res
      this.parseDocumentWeek()
      this.parseDocumentHour()
      this.parseUserWeek()
      this.parseUserHour()
      this.parseTotal()
    } catch (e) {
      this.$message({
        message: "có lỗi xảy ra",
        type: "error",
      })
    }
  },
  methods: {
    parseDocumentWeek() {
      this.documentWeekData.rows = []
      for (let i = 0; i < 7; i++) {
        let date = moment().subtract(i, "days")
        let formatted = date.format("00:00 DD/MM/YY")
        let dateData = this.statistic.filter(
          (s) => s.time === formatted && s.period === "7DAY" && s.type === "DOCUMENT"
        )
        this.documentWeekData.rows[6 - i] = {
          date: date.format("DD/MM"),
          total: (dateData.find((s) => s.status === "TOTAL") || { value: 0 }).value,
          complete: (dateData.find((s) => s.status === "COMPLETE") || { value: 0 }).value,
          error: (dateData.find((s) => s.status === "ERROR") || { value: 0 }).value,
        }
      }
    },
    parseDocumentHour() {
      this.documentHourData.rows = []
      for (let i = 0; i < 11; i++) {
        let date = moment().subtract(i, "hours")
        let formatted = date.format("hh:00 DD/MM/YY")
        let dateData = this.statistic.filter((s) => s.time === formatted && s.period === "24H" && s.type === "DOCUMENT")
        this.documentHourData.rows[10 - i] = {
          date: date.format("hh:00"),
          total: (dateData.find((s) => s.status === "TOTAL") || { value: 0 }).value,
          complete: (dateData.find((s) => s.status === "COMPLETE") || { value: 0 }).value,
          error: (dateData.find((s) => s.status === "ERROR") || { value: 0 }).value,
        }
        this.totalNewUploadDocument += this.documentHourData.rows[10 - i].total
      }
    },
    parseUserWeek() {
      this.userWeekData.rows = []
      for (let i = 0; i < 7; i++) {
        let date = moment().subtract(i, "days")
        let formatted = date.format("00:00 DD/MM/YY")
        let dateData = this.statistic.filter((s) => s.time === formatted && s.period === "7DAY" && s.type === "USER")
        this.userWeekData.rows[6 - i] = {
          date: date.format("DD/MM"),
          total: (dateData.find((s) => s.status === "TOTAL") || { value: 0 }).value,
          active: (dateData.find((s) => s.status === "ACTIVE") || { value: 0 }).value,
          inactive: (dateData.find((s) => s.status === "INACTIVE") || { value: 0 }).value,
        }
      }
    },
    parseUserHour() {
      this.totalNewRegisterUser = 0
      this.userHourData.rows = []
      for (let i = 0; i < 11; i++) {
        let date = moment().subtract(i, "hours")
        let formatted = date.format("hh:00 DD/MM/YY")
        let dateData = this.statistic.filter((s) => s.time === formatted && s.period === "24H" && s.type === "USER")
        this.userHourData.rows[10 - i] = {
          date: date.format("hh:00"),
          total: (dateData.find((s) => s.status === "TOTAL") || { value: 0 }).value,
          active: (dateData.find((s) => s.status === "ACTIVE") || { value: 0 }).value,
          inactive: (dateData.find((s) => s.status === "INACTIVE") || { value: 0 }).value,
        }
        this.totalNewRegisterUser += this.userHourData.rows[10 - i].total
      }
    },
    parseTotal() {
      this.totalUploadDocument = (
        this.statistic.find((s) => s.period === "ALL" && s.type === "DOCUMENT") || { value: 0 }
      ).value
      this.totalRegisterUser = (
        this.statistic.find((s) => s.period === "ALL" && s.type === "USER") || { value: 0 }
      ).value
    },
  },
}
</script>

<style scoped>
.center {
  alignment: center;
}
</style>
